import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Dairy from '../assets/icons/adminLogo.png';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const { onLogin } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const login = async () => {
    setIsLoading(true);
    const res = await onLogin({ email, password });

    if (res && res.error) {
      setIsLoading(false);
      alert(res.message);
    } else if (res && !res.error) {
      navigate('/');
      setIsLoading(false);
      alert('Admin Logged In Successfully');
    } else {
      alert(res.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-md w-full p-6 bg-white rounded-lg shadow-md">
        <img src={Dairy} alt="Dairy" className="w-20 h-20 mx-auto mb-6" />

        <h1 className="text-2xl font-bold text-center mb-4">Login as manager</h1>

        <div className="mb-4">
          <input
            type="email"
            placeholder="Admin Email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            className="w-full p-3 border rounded-md outline-none"
          />
        </div>

        <div className="mb-4 relative">
          <input
            type={isPasswordVisible ? 'text' : 'password'}
            placeholder="Password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            className="w-full p-3 border rounded-md outline-none"
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-transparent"
          >
            {isPasswordVisible ? 'Hide' : 'Show'}
          </button>
        </div>

        <button
          className="w-full py-3 bg-green-500 text-white rounded-md font-semibold mb-4"
          onClick={login}
          disabled={isLoading}
        >
          {isLoading ? 'Logging in...' : 'Login'}
        </button>

        <button
          className="w-full text-sm text-blue-500"
          onClick={() => alert('Forgot Password?')}
        >
          Forgot Password?
        </button>
      </div>
    </div>
  );
};

export default Login;
